import React, { useState, useEffect } from "react";
import { 
    Card, Row, Col, Button, Spinner, Alert, Form,
    InputGroup
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";

export default function SocieteTaxes() {
    const navigate = useNavigate();
    const [taxes, setTaxes] = useState({
        tva_taux: 18.00,
        css_taux: 1.00,
        tva_active: true,
        css_active: true
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        fetchTaxes();
    }, []);

    const fetchTaxes = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/parametres.php?action=taxes',
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            
            if (!response.ok) throw new Error("Erreur chargement");
            
            const result = await response.json();
            setTaxes(result.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setTaxes({
            ...taxes,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        setSaving(true);
        setError(null);
        setSuccess(false);
        
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/parametres.php',
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        action: 'update_taxes',
                        ...taxes
                    })
                }
            );
            
            const result = await response.json();
            
            if (result.success) {
                setSuccess(true);
                setTimeout(() => setSuccess(false), 3000);
            } else {
                setError("Erreur lors de la sauvegarde");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                        <Spinner animation="border" variant="primary" />
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">
                    {/* En-tête */}
                    <Row className="mb-4 fade-in">
                        <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center gap-3">
                                    <div 
                                        className="page-icon-wrapper d-flex align-items-center justify-content-center" 
                                        style={{ 
                                            width: '70px', 
                                            height: '70px', 
                                            borderRadius: '20px',
                                            background: 'linear-gradient(135deg, rgba(67, 97, 238, 0.15), rgba(58, 86, 212, 0.15))',
                                            boxShadow: '0 10px 20px rgba(67, 97, 238, 0.15)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0
                                        }}
                                    >
                                        <i className="ri-percent-line text-primary" style={{ fontSize: '36px', lineHeight: 1 }}></i>
                                    </div>
                                    <div>
                                        <h1 className="page-title mb-1">Taxes (TVA / CSS)</h1>
                                        <p className="text-muted mb-0">Configuration des taux de taxes</p>
                                    </div>
                                </div>
                                <Button variant="outline-secondary" onClick={() => navigate('/parametres')}>
                                    <i className="ri-arrow-left-line me-2"></i>Retour
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    {/* Messages */}
                    {success && (
                        <Alert variant="success" className="mb-4">
                            <i className="ri-checkbox-circle-line me-2"></i>
                            Taxes mises à jour avec succès
                        </Alert>
                    )}
                    
                    {error && (
                        <Alert variant="danger" className="mb-4">
                            <i className="ri-error-warning-line me-2"></i>
                            {error}
                        </Alert>
                    )}

                    {/* Formulaire */}
                    <Card className="border-0 shadow-sm">
                        <Card.Body className="p-4">
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <h5 className="mb-3">TVA</h5>
                                        
                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                type="switch"
                                                id="tva-active"
                                                name="tva_active"
                                                label="Activer la TVA"
                                                checked={taxes.tva_active}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                        
                                        {taxes.tva_active && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Taux de TVA (%)</Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        type="number"
                                                        name="tva_taux"
                                                        value={taxes.tva_taux}
                                                        onChange={handleChange}
                                                        step="0.01"
                                                        min="0"
                                                        max="100"
                                                        disabled={!taxes.tva_active}
                                                    />
                                                    <InputGroup.Text>%</InputGroup.Text>
                                                </InputGroup>
                                                <Form.Text className="text-muted">
                                                    Taux par défaut: 18%
                                                </Form.Text>
                                            </Form.Group>
                                        )}
                                    </Col>
                                    
                                    <Col md={6}>
                                        <h5 className="mb-3">CSS (Contribution Sociale)</h5>
                                        
                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                type="switch"
                                                id="css-active"
                                                name="css_active"
                                                label="Activer la CSS"
                                                checked={taxes.css_active}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                        
                                        {taxes.css_active && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Taux de CSS (%)</Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        type="number"
                                                        name="css_taux"
                                                        value={taxes.css_taux}
                                                        onChange={handleChange}
                                                        step="0.01"
                                                        min="0"
                                                        max="100"
                                                        disabled={!taxes.css_active}
                                                    />
                                                    <InputGroup.Text>%</InputGroup.Text>
                                                </InputGroup>
                                                <Form.Text className="text-muted">
                                                    Taux par défaut: 1%
                                                </Form.Text>
                                            </Form.Group>
                                        )}
                                    </Col>
                                </Row>

                                <div className="border-top pt-4 mt-4">
                                    <Button 
                                        type="submit" 
                                        variant="primary" 
                                        className="px-5"
                                        disabled={saving}
                                    >
                                        {saving ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Sauvegarde...
                                            </>
                                        ) : (
                                            'Enregistrer'
                                        )}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>

                <style>{`
                    .fade-in { animation: fadeIn 0.5s ease; }
                    @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
                `}</style>

                <Footer />
            </div>
        </>
    );
}